import React from "react";
import style from "./index.module.scss";
import CustomEmpty from "components/CourseComponents/CustomEmpty";

interface TopicEmptyProps {
    onAdd: () => void;
}

export default function TopicEmpty({ onAdd }: TopicEmptyProps) {
    return (
        <div className={style.root}>
            <CustomEmpty
                description={
                    <button className={style.add} onClick={onAdd}>
                        添加题目
                    </button>
                }
            />
        </div>
    );
}
